import React from "react";

const Hero = () => {
  return (
    <section>
      <div
        className="relative overflow-hidden bg-no-repeat bg-cover"
        style={{
          backgroundPosition: "",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1553484771-11998c592b9c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80')",
          height: "600px",
        }}
      >
        <div
          className="absolute top-0 right-0 bottom-0 left-0 w-full h-full overflow-hidden bg-fixed"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
        >
          <div className="flex justify-center items-center h-full">
            <div className="text-center text-white px-6 md:px-12">
              <h1
                className="text-5xl md:text-6xl xl:text-7xl font-bold tracking-tight mb-12"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                Forex Learning <span className="text-yellow-500">eBook </span>
              </h1>
              <div>
                <span
                  className="text-2xl font-normal text-yellow-400"
                  data-aos="fade-up"
                  data-aos-delay="500"
                  data-aos-duration="1300"
                >
                  Develop the necessary knowledge and techniques to trade the
                  financial markets. series of limited editions. <br />
                  Join today to improve your trading in just two weeks!
                </span>
              </div>

              <button
                // onClick={() => window.scrollBy(0, 400)}
                type="button"
                className="bg-yellow-500 px-5 py-3 rounded mt-4"
                data-mdb-ripple="true"
                data-mdb-ripple-color="light"
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
